<template>
  <div class="answer-block columns is-flex answer-template" :class="wrapperClass">
    <div class="is-flex" :class="{'mock-user' : !isDefaultCategory , 'label-default' : isDefaultCategory }">
      <label class="label">
        <div v-if="isCarousel.index === 0" class="circle-number" :class="{ 'circle-number-custom' : isDefaultCategory}">{{index + 1}}</div>
        <div v-if="!isValid.state && !inputData.isDefaultCarousel" class="circle-number warning" :title="isValid.reason">
          <span class="icon">
            <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
          </span>
        </div>
      </label>
    </div>
    <div class="column">
      <div class="answer-block-wrapper">
        <div class="close-btn-wrapper" v-show="isShowDeleteButton">
          <button class="button is-small is-danger is-inverted" @click="removeBlock">
            <span class="icon">
              <font-awesome-icon icon="times"></font-awesome-icon>
            </span>
          </button>
        </div>
        <div class="box answer-box">
          <label class="label is-small">
            <slot name="label"></slot>
          </label>
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import alice from '../../alice-api';

export default {
  name: 'AnswerTemplate',
  props: {
    answerType: String,
    inputData: Object,
    index: Number,
    wrapperClass: String,
    dataCategory: String,
    isCarousel: {
      type: Object,
      default() {
        return {
          index: 0
        };
      },
    }
  },
  methods: {
    removeBlock() {
      this.$buefy.dialog.confirm({
        title: `Removing ${this.answerType} block`,
        message: `Are you sure to remove this ${this.answerType} block?`,
        cancelText: 'Cancel',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$emit('deleted');
        },
      });
    },
  },
  computed: {
    isValid() {
      return alice.validateAnswer(this.inputData);
    },
    isShowDeleteButton() {
      if (this.answerType === 'category' || this.answerType === 'regex' || this.inputData.isDefaultCarousel) {
        return false;
      }
      return true;
    },
    isDefaultCategory() {
      // to not show label
      if (this.dataCategory === 'default') {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
  .answer-template {
    textarea {
      border-radius: 3px;
    }

    .answer-block-wrapper {
      .answer-box {
        min-width: 360px;
      }
    }
  }

  .label-default {
    padding: 0.75rem 0 0.75rem 0.75rem;
  }

   .circle-number-custom {
      border-radius: 16px;
      background-color: #fff;
      width: 30px;
      height: 30px;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #ddd;
   }
</style>
